/**
 * @hidden
 */
var isClassComponent = function isClassComponent(Component) {
  return Boolean(typeof Component === 'function' && !!Component.prototype.isReactComponent);
};
/**
 * @hidden
 */


var isForwardRef = function isForwardRef(Component) {
  return Boolean(Component.$$typeof && typeof Component.render === 'function');
};
/**
 * @hidden
 */


export var canUseRef = function canUseRef(Component) {
  return typeof Comment !== 'string' && (isClassComponent(Component) || isForwardRef(Component));
};